import React, { Component } from 'react'
import {
  Router,
  Switch,
  Route,
  Redirect
} from 'react-router-dom'

import ErrorPage from '~base/components/error-page'
import Layout from '~components/layout'

import SignUp from './pages/sign-up'
import LogIn from './pages/log-in'
import Profile from './pages/profile'
import PostCreate from './pages/post/create'
import PostDetail from './pages/post/detail'
import EmailInviteLanding from './pages/emails/invited'
import EmailResetLanding from './pages/emails/reset'
import ResetPassword from './pages/reset-password'
import createHistory from 'history/createBrowserHistory'
import PostListNew from './pages/post/list-new'
import PostListTop from './pages/post/list-top'
import PostListDomain from './pages/post/list-domain'
import PostListInvestor from './pages/post/list-investor'
import PostListStartup from './pages/post/list-startup'

import ReactGA from 'react-ga'
ReactGA.initialize('UA-61696460-16')

// #Import

class NotFoundPage extends Component {
  constructor (props) {
    super(props)

    this.state = {}
  }

  render () {
    return <ErrorPage message='Not found' />
  }
}

const AppRouter = () => {
  const history = createHistory()
  history.listen((location, action) => {
    ReactGA.set({ page: location.pathname })
    ReactGA.pageview(location.pathname)
  })

  return (<Router history={history}>
    <Layout>
      <Switch>
        <Route exact path='/' render={props => <Redirect to='/top' />} />
        {PostListNew.asRouterItem()}
        {PostListTop.asRouterItem()}
        {PostListDomain.asRouterItem()}
        {PostListInvestor.asRouterItem()}
        {PostListStartup.asRouterItem()}

        {PostCreate.asRouterItem()}
        {PostDetail.asRouterItem()}

        {SignUp.asRouterItem()}
        {LogIn.asRouterItem()}
        {Profile.asRouterItem()}

        {EmailInviteLanding.asRouterItem()}
        {EmailResetLanding.asRouterItem()}
        {ResetPassword.asRouterItem()}

        {/* Add routes here */}

        <Route component={NotFoundPage} />
      </Switch>
    </Layout>
  </Router>)
}

export default AppRouter



// WEBPACK FOOTER //
// ../frontend/router.js